import React, {useState} from 'react';
import '../../App.css'; 
import Navbar from '../navbar';
import TopNavbar from '../topnavbar'; 
import Footer from '../footer'; 
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button'; 
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css" 
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';


const HRIAssist = () => {

  const navigate = useNavigate(); 
  const currentYear = new Date().getFullYear();  
  const facility = sessionStorage.getItem("facility")
  // console.log(facility);

  const [submissions, setSubmissions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize] = useState(10);
  const [sortColumn, setSortColumn] = useState('');
  const [sortDirection, setSortDirection] = useState('asc');
  const [filter, setFilter] = useState({name: '',transactionType:'',status:'',month:'',year:''});
  // const [searhFilter, setSearchFilter] = useState(false) 
    
  const viewRequest = (data) => {
    navigate('/request', { state: { data } }) 
  };

     
  // sort submissions by columns
  const SortableHeader = ({ label, column, sortColumn, sortDirection, onSort }) => {
    const handleClick = () => {
      onSort(column);
    };
  
    return (
      <th onClick={handleClick} style={{ cursor: 'pointer' }}>
        {label} {sortColumn === column && <span>{sortDirection === 'asc' ? '↑' : '↓'}</span>}
      </th>
    );
  };
  const handleSort = (column) => {
    if (column === sortColumn) {
      // Reverse the sort direction if the same column is clicked again
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortColumn(column);
      setSortDirection('asc');
    }
  };
  const sortedSubmissions = [...submissions].sort((a, b) => {
    if (sortColumn) {
      const comparison = a[sortColumn].localeCompare(b[sortColumn]);
      return sortDirection === 'asc' ? comparison : -comparison;
    } else {
      return 0;
    }
  });
  
  // useEffect(() => {   
  //   if(Object.values(filter).every(value => value === '')){
  //     setSearchFilter(false)
  //   }
  //   if(!searhFilter){   
  //     getSubmissions(currentPage, pageSize, facility)   
  //   }else{  
  //     getFilteredSubmissions(currentPage, pageSize, facility)   
  //   }
  // }, [currentPage, pageSize, facility]);

  useEffect(() => {
    setCurrentPage(1);
    if (Object.values(filter).every(v => v === '')) {
      getSubmissions(1, pageSize, facility);
    } else {
      getFilteredSubmissions(1, pageSize, facility, filter);
    }
  }, [filter]);

  useEffect(() => {
    if (Object.values(filter).every(v => v === '')) {
      getSubmissions(currentPage, pageSize, facility);
    } else {
      getFilteredSubmissions(currentPage, pageSize, facility, filter);
    }
  }, [currentPage]);
  
  // get all the employee submissions
  const getSubmissions = async (pageNumber, pageSize, facility) => {
     
    const formData = new FormData(); 
    formData.append('pageNumber', pageNumber);
    formData.append('pageSize', pageSize);
    formData.append('facility', facility);
     
    try {
      const uploadResponse = await fetch('/api/hrsubmission', {
        method: 'POST',
        body: formData
      }) 
  
      if (!uploadResponse.ok) {
        console.error('Failed:', uploadResponse.statusText);
        return;
      } 

      try {
        const data = await uploadResponse.json();   
        setSubmissions(data.result.submissions) 
        setTotalPages(Math.ceil(data.result.count / pageSize))  
      } catch (error) {
          console.error('Error parsing JSON response:', error);
      }
 
    } catch (error) {
      console.error('Error:', error);
    }
  };  

  // get the submissions for download for report
  const downloadSubmissions = async () => {
     
  
    const formData = new FormData();  
    formData.append('name', filter.name);
    formData.append('transactionType', filter.transactionType);
    formData.append('status', filter.status);
    formData.append('month', filter.month);
    formData.append('year', filter.year);
    formData.append('facility', facility);
    
    try {
      const uploadResponse = await fetch('/api/hrdownloadsubmissions', {
        method: 'POST',
        body: formData
      }) 
  
      if (!uploadResponse.ok) {
        console.error('Failed:', uploadResponse.statusText);
        return;
      } 

      try { 
        const data = await uploadResponse.json();    
        exportToExcel(data.result.submissions); 
      } catch (error) {
          console.error('Error parsing JSON response:', error); 
          toast.error('No records found!', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light", 
          });
      }
 
    } catch (error) {
      console.error('Error:', error);
    }
  }; 

  // export the submissions as excel
  const exportToExcel = (data) => { 
    const workbook = XLSX.utils.book_new(); 
    const worksheet = autoAdjustColumnWidths(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1'); 
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' }); 
    const dataBlob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    

    let fileName = 'Submissions'
    if (filter.transactionType) {
      fileName += ' - ' + filter.transactionType;
    }
    if (filter.month) {
      fileName += ' - ' + filter.month;
    }
    if (filter.year) {
      fileName += ' - ' + filter.year;
    }
    if (filter.status) {
      fileName += ' - ' + filter.status;
    }
     
    
    saveAs(dataBlob, `${fileName}.xlsx`);
  };

  // adjust excel column width based on text length
  const autoAdjustColumnWidths = (data) => { 
    const worksheet = XLSX.utils.json_to_sheet(data);
    const colWidths = data.reduce((acc, row) => {
      Object.keys(row).forEach((key, index) => {
        const colLength = row[key] ? row[key].toString().length : 0;
        acc[index] = Math.max(acc[index] || 10, colLength);
      });
      return acc;
    }, []);
   
    worksheet['!cols'] = colWidths.map(width => ({ wch: width + 2 })); 
  
    return worksheet;
  };

  // get submissions based on filter
  // const getFilteredSubmissions = async (pageNumber, pageSize, facility) => {
  const getFilteredSubmissions = async (pageNumber, pageSize, facility, currentFilter = filter) => {
  
    const formData = new FormData(); 
    formData.append('pageNumber', pageNumber);
    formData.append('pageSize', pageSize); 
    formData.append('facility', facility); 
    // formData.append('name', filter.name);
    // formData.append('transactionType', filter.transactionType);
    // formData.append('status', filter.status);
    // formData.append('month', filter.month);
    // formData.append('year', filter.year);
    formData.append('name', currentFilter.name);
    formData.append('transactionType', currentFilter.transactionType);
    formData.append('status', currentFilter.status);
    formData.append('month', currentFilter.month);
    formData.append('year', currentFilter.year);
    
    try {
      const uploadResponse = await fetch('/api/hrfiltersubmission', {
        method: 'POST',
        body: formData
      }) 
  
      if (!uploadResponse.ok) {
        console.error('Failed:', uploadResponse.statusText);
        return;
      } 

      try {
        const data = await uploadResponse.json();    
        setSubmissions(data.result ? data.result.submissions:[]) 
        setTotalPages(data.result ? Math.ceil(data.result.count / pageSize):1)  
      } catch (error) {
          console.error('Error parsing JSON response:', error);
      }
 
    } catch (error) {
      console.error('Error:', error);
    }
  }; 
  
  // pagination
  const Pagination = ({ currentPage }) => { 
  
    const handleNextClick = () => {
      setCurrentPage(currentPage + 1);
    };
  
    const handlePreviousClick = () => {
      if (currentPage > 1) {
        setCurrentPage(currentPage - 1);
      }
    };
  
    return (
      <div className='pagination-btn'>
        <button onClick={handlePreviousClick} className="btn btn-sm btn-primary" disabled={currentPage === 1} >
          Previous
        </button>
        <span>Page {currentPage} of {totalPages}</span>
        <button onClick={handleNextClick} className="btn btn-sm btn-primary" disabled={currentPage === totalPages}>
          Next
        </button>
      </div>
    );
  };

  // pagination change page
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // filter requirements before retrieving
  // const filterSearch = () => {  
  //   const month = filter.month
  //   const year = filter.year
  //   if((month && year)||(!month && year) || (!month && !year))
  //   { 
  //     setSubmissions([])  
  //     if(Object.values(filter).every(value => value === '')){ 
  //       setSearchFilter(false) 
  //       getSubmissions(currentPage, pageSize, facility) 
  //     }else{  
  //       getFilteredSubmissions(currentPage, pageSize, facility) 
  //       setSearchFilter(true)
  //     }
  //   }else{
  //     toast.error('Year is required!', {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "light", 
  //     });
  //   }
  // };  
  // const handleFilterSubmit = (e) => {
  //   const { name, value } = e.target;
  //   setFilter((prevFilter) => ({
  //     ...prevFilter,
  //     [name]: value
  //   }));
  // };

  return (
    
          <div>
      <div id="wrapper">
         {/* Sidebar */}
         <Navbar />
            {/* Content Wrapper */}
      <div id="content-wrapper" className="d-flex flex-column">
        {/* Main Content */}
        <div id="content">
         {/* Topbar */}
         <TopNavbar />
            {/* Start of Page Content */}
            <div className="container-fluid">
              <div className="row justify-content-center">
                <div className="col-xl-12 col-lg-12"> 
                  {/* FILTER CONTAINER */}
                  <div className="card shadow-sm mb-3">
                    <div className="card-body py-3 px-3">

                      <div className="d-flex align-items-end flex-wrap" style={{ gap: "12px" }}>

                        {/* Name/User ID */}
                        <div className="flex-grow-1" style={{ minWidth: 200 }}>
                          <div className="d-flex align-items-center bg-light border rounded px-2" style={{ height: 38 }}>
                            <i className="fas fa-search text-muted mr-2" style={{ fontSize: 11 }}></i>
                            <input
                              type="text"
                              className="border-0 bg-transparent small"
                              style={{ outline: "none", height: "100%", width: 0, flexGrow: 1 }}
                              placeholder="Search by ID or Name"
                              value={filter.name}
                              onChange={(e) => setFilter(f => ({ ...f, name: e.target.value }))}
                            />
                          </div>
                        </div>

                        {/* Transaction Type */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Transaction Type</div>
                          <select
                            className="form-control form-control-sm"
                            style={{ width: 175 }}
                            value={filter.transactionType}
                            onChange={(e) => setFilter(f => ({ ...f, transactionType: e.target.value }))}
                          >
                            <option value="">All types</option>
                            <option value="SSS Loan">SSS Loan</option>
                            <option value="Pag-Ibig Landbank Card">Pag-Ibig Landbank Card</option>
                            <option value="Pag-Ibig DBP Card">Pag-Ibig DBP Card</option>
                            <option value="Pag-Ibig Virtual Account">Pag-Ibig Virtual Account</option>
                            <option value="Maternity Notification">Maternity Notification</option>
                            <option value="Maternity Benefit">Maternity Benefit</option>
                            <option value="Certification Request">Certification Request</option>
                          </select>
                        </div>

                        {/* Status */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Status</div>
                          <select
                            className="form-control form-control-sm"
                            style={{ width: 130 }}
                            value={filter.status}
                            onChange={(e) => setFilter(f => ({ ...f, status: e.target.value }))}
                          >
                            <option value="">All status</option>
                            <option value="Pending">Pending</option>
                            <option value="Resubmit">Resubmit</option>
                            <option value="Resubmitted">Resubmitted</option>
                            <option value="Complete">Complete</option>
                            <option value="Cancelled">Cancelled</option>
                            <option value="Expired">Expired</option>
                          </select>
                        </div>

                        {/* Month */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Month</div>
                          <select
                            className="form-control form-control-sm"
                            style={{ width: 120 }}
                            value={filter.month}
                            onChange={(e) => setFilter(f => ({ ...f, month: e.target.value }))}
                          >
                            <option value="">All months</option>
                            <option value="01">January</option>
                            <option value="02">February</option>
                            <option value="03">March</option>
                            <option value="04">April</option>
                            <option value="05">May</option>
                            <option value="06">June</option>
                            <option value="07">July</option>
                            <option value="08">August</option>
                            <option value="09">September</option>
                            <option value="10">October</option>
                            <option value="11">November</option>
                            <option value="12">December</option>
                          </select>
                        </div>

                        {/* Year */}
                        <div>
                          <div className="text-muted mb-1" style={{ fontSize: 11, fontWeight: "bold", letterSpacing: "0.06em" }}>Year</div>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="YYYY"
                            maxLength="4"
                            style={{ width: 90 }}
                            value={filter.year}
                            onChange={(e) => setFilter(f => ({ ...f, year: e.target.value }))}
                          />
                        </div>

                        {/* Download Button */}
                        <button
                          className="btn btn-sm btn-success"
                          style={{ height: 31 }}
                          onClick={downloadSubmissions}
                        >
                          <i className="fas fa-download mr-1"></i> Download
                        </button>

                        {/* Clear Button */}
                        <button
                          className="btn btn-sm btn-secondary"
                          style={{ height: 31 }}
                          onClick={() => setFilter({ name: '', transactionType: '', status: '', month: '', year: '' })}
                        >
                          Clear Filters
                        </button>

                      </div>

                      {/* Active pills */}
                      {(() => {
                        const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
                        const pills = [
                          filter.name            && { key: "name",  label: `Name: ${filter.name}`,                         onRemove: () => setFilter(f => ({ ...f, name: '' })) },
                          filter.transactionType && { key: "type",  label: `Type: ${filter.transactionType}`,              onRemove: () => setFilter(f => ({ ...f, transactionType: '' })) },
                          filter.status          && { key: "status",label: `Status: ${filter.status}`,                     onRemove: () => setFilter(f => ({ ...f, status: '' })) },
                          filter.month           && { key: "month", label: `Month: ${MONTHS[parseInt(filter.month) - 1]}`, onRemove: () => setFilter(f => ({ ...f, month: '' })) },
                          filter.year            && { key: "year",  label: `Year: ${filter.year}`,                         onRemove: () => setFilter(f => ({ ...f, year: '' })) },
                        ].filter(Boolean);

                        if (!pills.length) return null;
                        return (
                          <div className="d-flex align-items-center flex-wrap mt-2" style={{ gap: 6 }}>
                            {pills.map(p => (
                              <span key={p.key} className="badge d-inline-flex align-items-center"
                                style={{ background: "#eff2ff", color: "#3d52d5", border: "1px solid #c7d2fe", fontWeight: 500, fontSize: 11, padding: "3px 6px 3px 8px", borderRadius: 4 }}>
                                {p.label}
                                <button onClick={p.onRemove}
                                  style={{ background: "none", border: "none", padding: 0, marginLeft: 4, cursor: "pointer", color: "#3d52d5", opacity: 0.6, lineHeight: 1 }}>
                                  ✕
                                </button>
                              </span>
                            ))}
                            <span className="text-muted" style={{ fontSize: 11 }}>{pills.length} active filter{pills.length > 1 ? "s" : ""}</span>
                          </div>
                        );
                      })()}

                    </div>
                  </div>
                  <div className="card shadow mb-4"> 
                    <div className="card-body">
                      <div className="tab-content"> 
                        <div
                            className={`tab-pane fade show active `}
                            id="newHireReports"
                            role="tabpanel"
                            aria-labelledby="reports-tab"
                          > 
                          <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped">
                                    <thead>
                                        <tr> 
                                            <SortableHeader label="Name" column="Name" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} />
                                            <SortableHeader label="Transaction Type" column="TransactionType" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} />
                                            <SortableHeader label="Turn Around" column="TurnAround" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} />
                                            <SortableHeader label="Status" column="Status" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} />
                                            <SortableHeader label="Date Time" column="DateTime" sortColumn={sortColumn} sortDirection={sortDirection} onSort={handleSort} />
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                      {sortedSubmissions.map((sub, index) =>
                                        <tr key={index}>
                                            <td className='column'>
                                                  <label>{sub.Name}</label>
                                            </td>  
                                            <td className='column'>
                                                  <label>{sub.TransactionType}</label> 
                                            </td>  
                                            <td className='column'>
                                                  <label>{sub.TurnAround} Days</label> 
                                            </td>  
                                            <td className='column'>
                                              {sub.Status === 'Complete' && <label style={{color: 'blue'}}>{sub.Status}</label>}
                                              {sub.Status === 'Pending' && <label style={{color: 'green'}}>{sub.Status}</label>}
                                              {sub.Status === 'Resubmit' && <label style={{color: 'orange'}}>{sub.Status}</label>}
                                              {sub.Status === 'Resubmitted' && <label style={{color: 'green'}}>{sub.Status}</label>}
                                              {(sub.Status === 'Expired' || sub.Status === 'Cancelled') && <label style={{color: 'red'}}>{sub.Status}</label>}
                                            </td>  
                                            <td className='column'>
                                              <label>{sub.DateTime}</label> 
                                            </td> 
                                            {/* <button onClick={() => handleButtonClick(sub)}>Go to Next Page</button>  */}
                                            <td className='column'>
                                              <button type="button" 
                                              className="btn btn-primary m-2 float-end"
                                              onClick={() => viewRequest(sub)}>
                                                  View
                                              </button>
                                            </td>  
                                        </tr> 
                                      )}
                                    </tbody>
                                </table>
                                <div className='pagination'>
                                  <Pagination
                                    currentPage={currentPage}
                                    pageSize={pageSize}
                                    totalCount={submissions.length} // You may need to fetch the total count from the backend
                                    onPageChange={handlePageChange}
                                  />
                                </div>
                            <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /.container-fluid */}
          </div>
          {/* Footer */}
          <Footer />

          {/* End of Page Content */}
        </div>
        {/* End of Content Wrapper */}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light" 
        />
      </div>
      {/* End of Page Wrapper */}
      </div>
  );
}

export default HRIAssist;
